export default __webpack_public_path__ + "static/media/Deathpalms Gloves.f8dc9031.jpg";